import React from "react";
import Select from "react-select";
import TransitionChevron from "./../Widgets/TransitionChevron"
import styles from "./InlineSelectorStyles.module.scss"
import colors from "./../colors.scss"
import InlineLoader from "../Loaders/InlineLoader";
import classNames from "classnames";

const contentTypeSelectorStyles = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: "transparent",
        color: state.isFocused ? colors.primaryBlueHover : colors.textGrey,
        marginBottom: 5,
        cursor: "pointer"
    }),
    container: (provided) => ({
        ...provided,
        display: "inline-flex"
    }),
    singleValue: () => ({
        color: colors.textGrey,
        fontSize: 13,
        fontWeight: "bolder",
        display: "inline"
    }),
    control: () => ({
        width: "initial",
        display: "inline-grid",
        cursor: "pointer",
        alignItems: "center",
        gridTemplateColumns: "1fr 13px"
    }),
    valueContainer: () => ({
        display: "inline",
        paddingRight: 20,
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap"
    }),
    indicatorsContainer: () => ({
        display: "inline",
        position: "relative"
    }),
    indicatorSeparator: () => ({
        display: "none",
        color: "#2c5e9c"
    }),
    input: (provided) => ({
        ...provided,
        display: "inline"
    }),
    menuList: (provided) => ({
        ...provided,
        backgroundColor: "#fbfbfb",
        boxShadow: "4px 4px 15px 0 rgba(187, 187, 187, 0.5)",
        border: "none"
    }),
    menu: (provided) => ({
        ...provided,
        border: "none"
    })
};

const DropdownIndicator = ({selectProps: {menuIsOpen}}) => {
    return <TransitionChevron isActive={menuIsOpen} className={styles['chevron']} color="text"/>
};

export default React.memo(({label, onChange, value, options, name, isLoading, className, style, customSelectorStyles = {}}) => {
    return <div className={classNames(styles.base, className)} style={style}>
        <label>
            {label}
            {isLoading && <InlineLoader style={{alignSelf: "center"}}/>}
            {!isLoading && <Select components={{DropdownIndicator}} name={name}
                                   styles={{...contentTypeSelectorStyles, ...customSelectorStyles}} isSearchable={false}
                                   options={options} onChange={onChange} value={value}/>}
        </label>
    </div>
})
